import classnames from 'classnames';
import { FunctionComponent } from 'react';

type StoneCutRadiantProps = {
    className?: string;
};

const StoneCutRadiant: FunctionComponent<StoneCutRadiantProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'stone-cut-radiant'}
            viewBox="0 0 250 250"
        >
            <path d="M197.9-.5H50.6L6.5 45.7v156.1L52.6 250h146.9l44.6-47.2V46.7L197.9-.5zm17.5 52.2l-21.1-23 4.6-15.3 32.3 33-15.8 5.3zm-83.9 133.7l-.1.1-5.5 1.1-5.6-1.1v-.1l-.1.1-44.2-9-7-52.5 7-52.2 50-10.2 47.5 9.7 7.2 53.9 2 4.9-6.7 46.5-44.3 9-.2-.2zM75.1 62.8L67 36.1 108.3 56l-33.2 6.8zm-12.9 44.8l-20-44.9L67 71.1l-4.8 36.5zm-2.6 16.5L41 169.6V82.2l18.6 41.9zm2.7 17.2l4.8 35.9-22.5 7.6 17.7-43.5zm12.9 44.2l31.4 6.4-38 17.9 6.6-24.3zm99.3.5l6.7 22-35.5-16.1 28.8-5.9zm14.9-39.5l15.2 37.2-19.6-6.4 4.4-30.8zm2.6-17.6l.4-2.7 18.6-45v94.3l-19-46.6zm-3.8-16.1l-5.5-41 25.9-8.5-20.4 49.5zm-13.6-50.5L144 56.1l37.8-17.4-7.2 23.6zM129.1 53l-3.1-.6-3.1.6-41.7-20h91.4l-43.5 20zm-64 7.9l-20.7-7 13.9-15.3 6.8 22.3zm.4 126.3L59 211.5l-14.9-17.1 21.4-7.2zm55.9 7.7l4.6.9 4.7-1L175 215H78.9l42.5-20.1zm62.6-8.6l23.8 7.8-16.1 17.4-7.7-25.2zm.2-124.4l7.1-23.2L206 54.8l-21.8 7.1zm2.1-37.9h-123L58.6 8.5H191L186.3 24zm-131 4.6L35.1 50.9l-16-5.4 31.3-32.8 4.9 15.9zM32 59.3V189l-16.5 5.5V53.8L32 59.3zm2.9 138.2l21.3 24.4-3.9 14.7-32.5-34 15.1-5.1zm30 26.5h121.3l5.2 17h-131l4.5-17zm129.9-2.5l22.4-24.2 15 4.9-32.7 34.6-4.7-15.3zm25.2-32.8v-129l15-4.9v138.9l-15-5z" />
        </svg>
    );
};
export default StoneCutRadiant;
